import * as AlfredoComponents from "../../components";
import { useDecodedToken } from "../../services/jwt-decode.service";
import { useCombinedStore } from "../../store";
import * as AlfredoStyles from "../../styles/global/global";
import * as AlfredoInterfaces from "../../store/../interfaces";
import Configuration from "../../components/configuration/index";
import { useDecryptedInfoToken } from "../../hooks/useDecryptedInfoToken";

const SettingsPage: React.FC = () => {
  const { authUserZustand, organizationZustand } = useCombinedStore();
  const decryptedToken: any = useDecodedToken(authUserZustand?.Token);
  const decryptedInfoToken = useDecryptedInfoToken();

  return (
    <AlfredoStyles.Container>
      <AlfredoComponents.Breadcrumb />
      <AlfredoStyles.FlexContainer>
        <AlfredoStyles.FlexItem>
          <Configuration
            decryptedInfoToken={decryptedInfoToken}
            decryptedToken={decryptedToken}
          />
        </AlfredoStyles.FlexItem>
      </AlfredoStyles.FlexContainer>
    </AlfredoStyles.Container>
  );
};

export default SettingsPage;
